import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left - Text Content */}
          <div className="lg:w-[45%] flex flex-col justify-center">
            <span className="inline-block text-xs font-medium uppercase tracking-widest text-foreground-400 border border-foreground-200/70 px-3 py-1 rounded-full mb-6">
              About This Resource
            </span>

            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight mb-8">
              Why Every Shopper Needs a{' '}
              <span className="text-primary-600">Sugargoo Spreadsheet</span>
            </h2>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              The Sugargoo spreadsheet has become an essential tool for savvy shoppers navigating the world of
              replica and budget-friendly fashion. With thousands of products listed across dozens of categories,
              finding the right item can feel overwhelming without a properly organized resource.
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              Our curated Sugargoo spreadsheet watch platform brings together the most reliable, verified finds
              from trusted sellers, updated regularly to ensure you always have access to the latest and
              highest-quality products. Whether you are hunting for the perfect pair of sneakers, a cozy hoodie,
              or a statement accessory, our organized category system makes discovery effortless.
            </p>

            {/* Data points */}
            <div className="flex items-center gap-12 mb-8">
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-foreground-900">1000+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Verified Products</p>
              </div>
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-foreground-900">14</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Categories</p>
              </div>
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-foreground-900">Daily</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Updates</p>
              </div>
            </div>

            <Link
              to="/sugargoo-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors border-b-2 border-primary-500 pb-1 w-fit cursor-pointer"
            >
              Read Our Complete Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Right - Image Stack */}
          <div className="lg:w-[55%] relative">
            <div className="relative h-[500px] md:h-[600px]">
              {/* Top-left small image */}
              <div className="absolute top-0 left-0 w-44 md:w-56 h-44 md:h-56 rounded-xl overflow-hidden z-20 bg-secondary-100/80">
                <img
                  src="https://readdy.ai/api/search-image?query=Crisp%20white%20premium%20leather%20sneakers%20with%20natural%20sunlight%20highlighting%20texture%20on%20cream%20linen%2C%20editorial%20detail%20photography%2C%20warm%20morning%20light%20casting%20gentle%20shadows%2C%20fresh%20clean%20aesthetic&width=560&height=560&seq=about-sneak-v2-2026&orientation=squarish"
                  alt="Premium sneakers from Sugargoo Spreadsheet verified sellers"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Bottom-right larger image */}
              <div className="absolute top-16 right-0 w-60 md:w-80 h-[400px] md:h-[480px] rounded-xl overflow-hidden z-10 bg-primary-50/80">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylish%20neutral%20tone%20oversized%20sweater%20elegantly%20displayed%20on%20minimalist%20stand%20with%20soft%20studio%20lighting%2C%20editorial%20fashion%20photography%2C%20warm%20beige%20and%20cream%20palette%2C%20sophisticated%20clean%20composition&width=800&height=1200&seq=about-fashion-v2-2026&orientation=portrait"
                  alt="Designer-inspired sweater from Sugargoo Spreadsheet"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Decorative element */}
              <div className="absolute bottom-8 left-20 w-20 h-20 rounded-full bg-accent-100/50 z-0"></div>
              <div className="absolute top-32 right-10 w-12 h-12 rounded-full bg-primary-200/40 z-0"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}